import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { useIntl } from 'react-intl'

import { Button } from 'antd'
import { CheckSystem, UrlQueryParamsParse } from '../common/globalFun'
import openApp from '../common/openApp'
import PageBg from '../components/PageBg'
import HeaderLogo from '../components/HeaderLogo'

import './css/openApp.css'

const defaultScheme = 'felo://join.felo.me/'

const OpenAppPage = (props) => {
  const intl = useIntl()

  const [scheme, setScheme] = useState('')
  const [iframeKey, setIframeKey] = useState(0)

  const resetIframe = () => {
    let schemeUrl = scheme
    const feloScheme = defaultScheme
    if (schemeUrl.indexOf(feloScheme) === -1) {
      schemeUrl = feloScheme
    }
    openApp.open(
      schemeUrl,
      (code) => {
        switch (code) {
          case 'ios':
            break
          case 'android':
            break
        }
      },
      () => {
        setIframeKey(iframeKey + 1)
        iosOpenScheme(scheme ? scheme : '')
      },
      2000
    )
  }

  const iosOpenScheme = (url) => {
    if (CheckSystem.iOS()) {
      setTimeout(() => {
        window.location.href = scheme ? scheme : url
      }, 10)
    }
  }

  const systemName = () => {
    if (CheckSystem.iOS()) {
      return 'iOS'
    }
    if (CheckSystem.Android()) {
      return 'Android'
    }
    if (CheckSystem.MAC()) {
      return 'macOS'
    }
    return 'Windows'
  }

  const getUrlScheme = () => {
    return new Promise((resolve, reject) => {
      const { search, hash } = window.location
      let urlQuery = search
      if (!urlQuery) {
        urlQuery = hash.slice(hash.indexOf('?'), hash.length)
      }
      const urlQuertParamsStr = urlQuery.replace(/^\?/, '')
      const queryParamsData = UrlQueryParamsParse(urlQuertParamsStr)
      if (queryParamsData && queryParamsData.scheme) {
        const scheme = decodeURIComponent(queryParamsData.scheme)
        resolve(scheme)
      } else {
        reject()
      }
    })
  }

  useEffect(() => {
    getUrlScheme()
      .then((schemeBase64) => {
        const scheme = window.decodeURIComponent(window.atob(schemeBase64))
        console.log('scheme', scheme)
        setScheme(scheme)
        iosOpenScheme(scheme)
      })
      .catch(() => {
        setScheme(defaultScheme)
        iosOpenScheme(defaultScheme)
      })
  }, [])

  return (
    <div className="chatter-channel-page">
      <PageBg />

      <section className="appinfo">
        <div className="appinfo-header">
          <HeaderLogo />
        </div>
      </section>

      <section className="download">
        <div className="download-not-install">
          {intl.formatMessage({ id: 'download.not.install' })}
        </div>
        <Button
          type="primary"
          className="download-btn"
          variant="outlined"
          color="primary"
          href="https://www.felo.me/download"
        >
          {intl.formatMessage({ id: 'download.pkg' }, { name: systemName() })}
        </Button>
        <div className="download-installed">
          <span>{intl.formatMessage({ id: 'already.install.felo' })}</span>
          <Button type="link" color="primary" onClick={resetIframe}>
            {intl.formatMessage({ id: 'open.now' })}
          </Button>
        </div>
      </section>
      <div className="select-lang"></div>
      <iframe title="scheme" hidden src={scheme} key={iframeKey} />
    </div>
  )
}

const stateProps = () => {}

const dispatchProps = () => ({})

export default connect(stateProps, dispatchProps)(OpenAppPage)
